import React from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the default styles
import "./status-page-carousel.css"; // Import your custom styles

// Importing images from src/images/screenshots
import screenshot1 from "../images/screenshots/status.broadcom.com_services_carbon-black.webp";
import screenshot3 from "../images/screenshots/ssems.gravityzone.bitdefender.com.webp";
import screenshot4 from "../images/screenshots/status.replit.com.webp";
import screenshot5 from "../images/screenshots/status.postmarkapp.com.webp";

const StatusPages = () => {
  const screenshots = [
    screenshot1,
    screenshot3,
    screenshot4,
    screenshot5
    // Add more screenshots as needed
  ];

  return (
    <div className="py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flow-root">
          <div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
            <Carousel
              autoPlay
              showThumbs={false}
              showStatus={false}
              showArrows={true}
              showIndicators={false}
              interval={4500}
              transitionTime={500}
            >
              {screenshots.map((src, index) => (
                <div key={index}>
                  <img src={src} alt={`Screenshot ${index + 1}`} width="1216" height="721" className="rounded-md shadow-2xl ring-1 ring-gray-900/10" />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatusPages;